//REACT-JS
import React from 'react';
import { withRouter, Link } from 'react-router-dom';

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//COMPONENTS
import { relatorioAction } from '../../store/relatorio';

class TableDetalheContatoUnificadoToi extends React.Component {

    constructor(props) {
        super(props);
    }

    static defaultProps = {
        name: "",
        selected: 0,
        onChange: function(e){}
    };

    componentDidMount() {
        
    }

    statusEnvio(status){
        if (status == "Enviado"){
            return( <span style={{color:"#009966"}}>Enviado</span>)
        }
        else if (status == "Entregue"){
            return( <span style={{color:"#EF7800"}}>Entregue</span>)
        }
        else if (status == "Aberto"){
            return( <span style={{color:"#0099FF"}}>Aberto</span>)
        }
        else if (status == "Rejeitado"){
            return( <span style={{color:"#C34E4E"}}>Não Entregue</span>)
        }
        else if (status == "Nao Enviado"){
            return(<td style={{color:"#C34E4E"}}>Não Enviado</td>)
        }
    }

    statusEnvioSms(statusSMS){
        if (statusSMS == "Enviado"){
            return( <span style={{color:"#009966"}}>Enviado</span>)
        }
        else if (statusSMS == "Entregue"){
            return( <span style={{color:"#EF7800"}}>Entregue</span>)
        }
        else if (statusSMS == "Aberto"){
            return( <span style={{color:"#0099FF"}}>Abertura Link</span>)
        }
        else if (statusSMS == "Entregue Aparelho"){
            return( <span style={{color:"#0099FF"}}>Entregue no Aparelho</span>)
        }
        else if (statusSMS == "Rejeitado"){
            return( <span style={{color:"#C34E4E"}}>Não Entregue</span>)
        }
        else if (statusSMS == "Nao Enviado"){
            return(<td style={{color:"#C34E4E"}}>Não Enviado</td>)
        }
    }

    render() {

        const data = this.props.data; let html = "";

        let medidorVariavel;

        if (data.results === undefined) {
            html = (<tr><td colSpan="7" scope="row">Carregando...</td></tr>);
        }
        else if (data.results.length === 0 || data.results === 0) {
            html = (<tr><td colSpan="7" scope="row">Nenhum registro encontrado.</td></tr>);
        }
        else if (data.results.length > 0) {
            html = data.results.map(row =>
                <tr key={row.identificador} id={row.codigo}>
                    <td>{row.identificador}</td>
                    <td>{row.nomeCampanha}</td>
                    <td style={{display: "none"}}>{row.prioridade}</td>
                    <td>{row.email}</td>
                    <td>{row.telefone}</td>
                    <td style={{display: "none"}}>{row.empresa}</td>
                    <td>{row.uc}</td>
                    <td style={{display: "none"}}>{row.protocolo}</td>
                    <td style={{display: "none"}}>{row.documento}</td>
                    <td>{this.statusEnvio(row.status)}</td>
                    <td style={{display: "none"}}>{row.dataHoraEnvio}</td>
                    <td style={{display: "none"}}>{row.dataHoraEntrega}</td>
                    <td style={{display: "none"}}>{row.dataHoraAbertura}</td>
                    <td style={{display: "none"}}>{row.motivoNaoRecebimento}</td>
                    <td>{this.statusEnvioSms(row.statusSMS)}</td>
                    <td style={{display: "none"}}>{row.dataHoraEnvioSms}</td>
                    <td style={{display: "none"}}>{row.dataHoraEntregaSms}</td>
                    <td style={{display: "none"}}>{row.dataHoraAberturaSms}</td>
                    <td style={{display: "none"}}>{row.motivoNaoRecebimentoSms}</td>
                    {/*
                    <td style={{display: "none"}}>{row.dataHoraEnvioWhatsapp}</td>
                    <td style={{display: "none"}}>{row.dataHoraEntregaWhatsapp}</td>
                    <td style={{display: "none"}}>{row.dataHoraAberturaWhatsapp}</td>
                    <td style={{display: "none"}}>{row.motivoNaoRecebimentoWhatsapp}</td>
                     */}
                    <td style={{display: "none"}}>{row.mailing}</td>
                </tr>                  
            );
        }

        if (data.results) {
            if (data.results.some(row => row.empresa === "3CSERVICE RJ")) {
                medidorVariavel = "Medidor";
            } else {
                medidorVariavel = "Protocolo";
            }
        }

        return(
            <div style={{maxHeight: "400px", overflowY: "auto"}}>
                <table className="footable table table-striped toggle-arrow-tiny text-body" id="table-to-export">
                    <thead>
                        <tr style={{backgroundColor: "#dbf1e9"}}>       
                            <th>Identificador</th>
                            <th>Rotina</th>
                            <th style={{display: "none"}}>Prioridade de Envio</th>
                            <th>E-mail</th>
                            <th>SMS</th>
                            <th style={{display: "none"}}>Empresa</th>
                            <th>UC</th>
                            <th style={{display: "none"}}>{medidorVariavel}</th>
                            <th style={{ display: "none" }}>Documento</th>
                            <th>Status E-mail</th>
                            <th style={{display: "none"}}>Data/Hora do envio E-mail</th> 
                            <th style={{display: "none"}}>Data/Hora entrega E-mail</th>
                            <th style={{display: "none"}}>Data/Hora abertura E-mail</th>
                            <th style={{display: "none"}}>Motivo não recebimento E-mail</th>
                            <th>Status SMS</th>
                            <th style={{display: "none"}}>Data/Hora envio SMS</th> 
                            <th style={{display: "none"}}>Data/Hora entrega SMS</th>
                            <th style={{display: "none"}}>Data/Hora abertura Link</th>
                            <th style={{display: "none"}}>Motivo não recebimento SMS</th>
                            {/*
                            <th style={{display: "none"}}>Data/Hora envio Whatsapp</th> 
                            <th style={{display: "none"}}>Data/Hora entrega Whatsapp</th>
                            <th style={{display: "none"}}>Data/Hora abertura Whatsapp</th>
                            <th style={{display: "none"}}>Motivo não recebimento Whatsapp</th>
                            */}
                            <th style={{display: "none"}}>Mailing</th>
                        </tr>
                    </thead>

                    <tbody>{html}</tbody>
                </table>            
            </div>
        )
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth, relatorio: state.relatorio };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { relatorio: bindActionCreators(relatorioAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TableDetalheContatoUnificadoToi));